<template>

  <!-- Main Footer -->
  <footer class="main-footer">
    <!-- To the right -->
    <div class="float-right d-none d-sm-inline">
      VentaXpress
    </div>
    <!-- Default to the left -->
    <strong>Copyright &copy; 2025 <a href="https://digitalnaen.com" target="_blank">DigitalNaen EIRL</a>.</strong> Todos los derechos reservados
  </footer>

</template>